import { z } from 'zod';
import { CONTENT_PACKAGE_FORMAT_VERSION } from './versions';
import { recipeDefinitionSchema } from './recipe.schema';

const libraryStatus = z.enum(['draft', 'active', 'deprecated', 'archived']);
const supervision = z.enum(['every_step', 'plan_and_irreversible', 'plan_only']);

export const packagedRoleTemplateSchema = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  purpose: z.string(),
  baseInstruction: z.string(),
  defaultTools: z.array(z.string()).default([]),
  defaultChecklists: z.array(z.string()).default([]),
  defaultSupervision: supervision.default('every_step'),
  defaultModel: z.string().optional(),
  version: z.number().int().positive(),
  status: libraryStatus.default('draft'),
});

export const checklistItemSchema = z.object({
  id: z.string().min(1),
  text: z.string().min(1),
  severity: z.enum(['hard', 'soft']),
});

export const packagedSkillSchema = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  kind: z.enum(['instruction', 'checklist', 'artifact_template']),
  body: z.union([z.string(), z.array(checklistItemSchema), z.record(z.string(), z.unknown())]),
  requiredTools: z.array(z.string()).default([]),
  examples: z.array(z.unknown()).default([]),
  version: z.number().int().positive(),
  status: libraryStatus.default('draft'),
});

export const packagedRecipeSchema = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  description: z.string().optional(),
  version: z.number().int().positive(),
  status: libraryStatus.default('draft'),
  definition: recipeDefinitionSchema,
});

export const contentPackageSchema = z.object({
  formatVersion: z.literal(CONTENT_PACKAGE_FORMAT_VERSION),
  name: z.string().min(1),
  exportedAt: z.string().datetime(),
  roleTemplates: z.array(packagedRoleTemplateSchema).default([]),
  skills: z.array(packagedSkillSchema).default([]),
  recipes: z.array(packagedRecipeSchema).default([]),
});

export type ContentPackage = z.infer<typeof contentPackageSchema>;
export type ChecklistItem = z.infer<typeof checklistItemSchema>;
